import type { PlaceId } from '../hub/hub-model';

/** Simple flat pictures for children who cannot read yet (ADR 0017). Decorative: callers label them. */

export function BunnyPicture() {
  return (
    <svg viewBox="0 0 120 120" aria-hidden="true" focusable="false">
      <ellipse cx="45" cy="26" rx="9" ry="24" fill="#f5f2ea" />
      <ellipse cx="75" cy="26" rx="9" ry="24" fill="#f5f2ea" />
      <ellipse cx="45" cy="28" rx="4" ry="16" fill="#f3b6c0" />
      <ellipse cx="75" cy="28" rx="4" ry="16" fill="#f3b6c0" />
      <circle cx="60" cy="68" r="34" fill="#f5f2ea" />
      <circle cx="48" cy="64" r="5" fill="#1d3036" />
      <circle cx="72" cy="64" r="5" fill="#1d3036" />
      <ellipse cx="60" cy="76" rx="5" ry="4" fill="#ea8a44" />
    </svg>
  );
}

export function RocketPicture() {
  return (
    <svg viewBox="0 0 120 120" aria-hidden="true" focusable="false">
      <path d="M60 10c18 14 26 36 22 62H38C34 46 42 24 60 10z" fill="#f5f2ea" />
      <circle cx="60" cy="46" r="10" fill="#2876a7" />
      <path d="M38 72l-14 20 18-6zM82 72l14 20-18-6z" fill="#ea8a44" />
      <path d="M48 76h24l-12 30z" fill="#f2c14e" />
    </svg>
  );
}

export function MoonPicture() {
  return (
    <svg viewBox="0 0 120 120" aria-hidden="true" focusable="false">
      <path d="M78 18a42 42 0 1 0 24 62A34 34 0 0 1 78 18z" fill="#f2c14e" />
      <circle cx="28" cy="26" r="3" fill="#fff" />
      <circle cx="98" cy="30" r="2.5" fill="#fff" />
      <circle cx="16" cy="70" r="2" fill="#fff" />
    </svg>
  );
}

export function PlacePicture({ place }: { place: PlaceId }) {
  switch (place) {
    case 'cinema':
      return (
        <svg viewBox="0 0 100 100" aria-hidden="true" focusable="false">
          <rect x="12" y="34" width="76" height="52" rx="8" fill="#ea8a44" />
          <path
            d="M12 34l10-20 14 4-10 20zM36 18l14 4-10 20M50 22l14 4-10 20M64 26l14 4-10 20"
            fill="#1d3036"
          />
          <path d="M42 50v22l20-11z" fill="#fff" />
        </svg>
      );
    case 'lab':
      return (
        <svg viewBox="0 0 100 100" aria-hidden="true" focusable="false">
          <circle cx="50" cy="42" r="24" fill="#f2c14e" />
          <rect x="40" y="64" width="20" height="16" rx="3" fill="#52636a" />
          <path d="M44 42l6 10 6-10" stroke="#a95718" strokeWidth="4" fill="none" />
        </svg>
      );
    case 'workshop':
      return (
        <svg viewBox="0 0 100 100" aria-hidden="true" focusable="false">
          <rect x="20" y="52" width="60" height="30" rx="6" fill="#a46e46" />
          <path d="M30 52l20-24 20 24z" fill="#d9a066" />
          <rect x="44" y="62" width="12" height="20" fill="#5b3a22" />
        </svg>
      );
    case 'treehouse':
      return (
        <svg viewBox="0 0 100 100" aria-hidden="true" focusable="false">
          <circle cx="50" cy="36" r="26" fill="#6fa36b" />
          <rect x="44" y="56" width="12" height="30" fill="#8a5a36" />
          <rect x="34" y="40" width="32" height="18" rx="3" fill="#c98a4e" />
        </svg>
      );
    case 'tower':
      return (
        <svg viewBox="0 0 100 100" aria-hidden="true" focusable="false">
          <circle cx="50" cy="44" r="28" fill="#2876a7" />
          <path
            d="M32 34c8 4 14-2 22 2s6 12 14 10M30 52c10-2 12 6 20 6"
            stroke="#8fc1e3"
            strokeWidth="5"
            fill="none"
            strokeLinecap="round"
          />
          <rect x="38" y="76" width="24" height="8" rx="3" fill="#a46e46" />
        </svg>
      );
  }
}
